var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Yup from 'yup';
import React from 'react';
import { Wizard } from 'rhf-wizard';
import Footer from './Footer';
import Header from './Header';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Step7 from './Step7';
import Step8 from './Step8';
const flattenObject = (obj) => {
    const flattened = {};
    Object.values(obj).forEach((nestedObj) => {
        Object.entries(nestedObj).forEach(([key, value]) => {
            flattened[key] = (typeof value === "object" && value !== null)
                ? JSON.stringify(value)
                : value;
        });
    });
    return flattened;
};
const steps = [
    {
        id: "Step1",
        component: React.createElement(Step1, null),
        initialValues: {
            locationFile: "",
            locationArea: null
        },
        validationSchema: Yup.object().shape({
            locationFile: Yup.string(),
            locationArea: Yup.array(Yup.object().shape({
                lat: Yup.number().required(),
                lng: Yup.number().required(),
            })).nullable()
                .when('locationFile', {
                is: (val) => !(val === null || val === void 0 ? void 0 : val.trim()),
                then: (schema) => schema.required('You must either upload your location file or select an area on the map'),
            }),
        })
    },
    {
        id: "Step2",
        component: React.createElement(Step2, null),
        initialValues: {
            phase: ""
        },
        validationSchema: Yup.object().shape({
            phase: Yup.string().required("Phase is required")
        })
    },
    {
        id: "Step3",
        component: React.createElement(Step3, null),
        initialValues: {
            services: ""
        },
        validationSchema: Yup.object().shape({
            services: Yup.array().required("Service is required").min(1, "You must select at least one service")
        })
    },
    {
        id: "Step4",
        component: React.createElement(Step4, null),
        initialValues: {
            output: []
        },
        validationSchema: Yup.object().shape({
            output: Yup.array().required("Output is required").min(1, "You must select at least one option")
        })
    },
    {
        id: "Step5",
        component: React.createElement(Step5, null),
        initialValues: {
            expertise: ["base"]
        },
        validationSchema: Yup.object().shape({
            expertise: Yup.array().required("Expertise is required").min(1, "You must select at least one option")
        })
    },
    {
        id: "Step6",
        component: React.createElement(Step6, null),
        initialValues: {
            tolerance: ""
        },
        validationSchema: Yup.object().shape({
            tolerance: Yup.string().required("Tolerance is required")
        })
    },
    {
        id: "Step7",
        component: React.createElement(Step7, null),
        initialValues: {
            name: "",
            email: "",
            organisation: "",
            phone: "",
            additional: "",
            attachment: "",
            acceptTerms: "",
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required("Name is required").max(80),
            email: Yup.string().required("Email is required").email("Invalid email").max(100),
            organisation: Yup.string().required("Organisation is required").max(80),
            phone: Yup.string().max(20),
            additional: Yup.string().max(2000),
            attachment: Yup.string(),
            acceptTerms: Yup.string().required("You must accept the terms and conditions"),
        }),
        onSubmit: (stepValues, allValues) => __awaiter(void 0, void 0, void 0, function* () {
            const mergedValues = Object.assign(Object.assign({}, flattenObject(allValues)), stepValues);
            //Submit form
            try {
                const response = yield fetch("/ajax/submit-quote", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept': '*/*'
                    },
                    body: new URLSearchParams(mergedValues)
                });
                const data = yield response.json();
                //TODO: Check response for any errors: success = true | false, error = string
                //alert("All complete")
                return;
            }
            catch (error) {
                alert("An error occurred");
            }
        })
    },
    {
        id: "Step8",
        component: React.createElement(Step8, null),
        hideNext: true,
        hidePrevious: true
    },
];
// ─── Debugging ───────────────────────────────────────────────────────────────
//Enable this to test certain steps quickly
// const START_STEP = 5; steps.splice(0, START_STEP - 1)
const QuoteModal = ({ isOpen, onClose }) => {
    if (!isOpen)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Wizard, { steps: steps, onStepChanged: (fromStep, toStep, wizardValues) => {
                console.log('Step changed', fromStep.id, toStep.id, wizardValues);
            }, onCompleted: (values) => {
                //All done. Nothing required here
            }, header: React.createElement(Header, null), footer: React.createElement(Footer, null) })));
};
export default QuoteModal;
